// A template's own PDP hides webshop core's reviews section outright
// (item.html: `{% if ... and not doc.has_variants %}`), regardless of
// whether the template's own Website Item actually has reviews — and on
// this site it's the only Website Item a review could ever be recorded
// against (variants never get their own). This renders that same data in
// the same structural spot item_reviews.html would occupy for a
// non-template item, plus a "Write a Review" path of its own: core's
// version lives entirely inside item_reviews.html's inline <script>, so a
// template page has no submission flow to reuse — this rebuilds the same
// dialog against get_template_review_eligibility/add_template_review, which
// gate on an actual submitted order rather than core's own "has any
// Customer record at all" check.
//
// Detection reuses pdp_variant_swatches.js's exact guard, verbatim, for
// consistency between the two PDP-template scripts in this app.
frappe.ready(function () {
	var page = document.querySelector('[data-doctype="Website Item"][source-type="Generator"]');
	if (!page) return;

	var configureBtn = document.querySelector('.btn-configure');
	if (!configureBtn) return; // not a template PDP

	var templateItemCode = configureBtn.getAttribute('data-item-code');
	if (!templateItemCode) return;

	function call(method, args) {
		return new Promise(function (resolve) {
			frappe.call({
				method: method,
				args: args,
				callback: function (r) {
					resolve(r && r.message);
				},
				error: function () {
					resolve(null);
				},
			});
		});
	}

	Promise.all([
		call('raftor_webhq.catalog.api.get_template_review_aggregate', { item_code: templateItemCode }),
		call('raftor_webhq.catalog.api.get_template_review_eligibility', { item_code: templateItemCode }),
	]).then(function (results) {
		var data = results[0] || { average: null, count: 0, recent: [] };
		var eligibility = results[1] || { eligible: false };

		// Nothing to show and nothing to invite — same no-op as before.
		if (!data.count && !eligibility.eligible) return;

		var anchor = document.querySelector('.product-container.mt-4 .product-page-content');
		if (!anchor) return;

		var section = document.createElement('div');
		section.className = 'rfhq-template-reviews mt-4';
		section.innerHTML = buildMarkup(data, eligibility);
		anchor.appendChild(section);

		if (eligibility.eligible) {
			var btn = section.querySelector('.rfhq-tr-write-btn');
			if (btn) btn.addEventListener('click', function () { openReviewDialog(templateItemCode); });
		}
	});

	function starRow(value) {
		var full = Math.round(value);
		var out = '';
		for (var i = 1; i <= 5; i++) {
			out += '<span class="rfhq-tr-star' + (i <= full ? ' rfhq-tr-star--full' : '') + '">&#9733;</span>';
		}
		return out;
	}

	function buildMarkup(data, eligibility) {
		var writeBtn = eligibility.eligible
			? '<button type="button" class="btn btn-sm btn-default rfhq-tr-write-btn">' + __('Write a Review') + '</button>'
			: '';

		var summary = data.count
			? '<div class="rfhq-tr-summary">' +
					'<div class="rfhq-tr-stars">' + starRow(data.average) + '</div>' +
					'<span class="rfhq-tr-average">' + frappe.utils.escape_html(Number(data.average).toFixed(1)) + '</span>' +
					'<span class="rfhq-tr-count">(' + frappe.utils.escape_html(String(data.count)) + ' ' + __('reviews across sizes/colours') + ')</span>' +
				'</div>'
			: '<p class="rfhq-tr-empty text-muted">' + __('No reviews yet.') + '</p>';

		var html =
			'<div class="rfhq-tr-header">' +
				'<h4 class="rfhq-tr-heading">' + __('Ratings & Reviews') + '</h4>' +
				writeBtn +
			'</div>' +
			summary;

		(data.recent || []).forEach(function (row) {
			var stars = starRow((row.rating || 0) * 5);
			var title = frappe.utils.escape_html(row.review_title || '');
			var comment = frappe.utils.escape_html(row.comment || '');
			html +=
				'<div class="rfhq-tr-item">' +
					'<div class="rfhq-tr-item-stars">' + stars + '</div>' +
					(title ? '<div class="rfhq-tr-item-title">' + title + '</div>' : '') +
					(comment ? '<p class="rfhq-tr-item-comment">' + comment + '</p>' : '') +
				'</div>';
		});

		return html;
	}

	function openReviewDialog(itemCode) {
		var d = new frappe.ui.Dialog({
			title: __('Write a Review'),
			fields: [
				{ fieldname: 'title', fieldtype: 'Data', label: __('Headline'), reqd: 1 },
				{ fieldname: 'rating', fieldtype: 'Rating', label: __('Overall Rating'), reqd: 1 },
				{ fieldtype: 'Section Break' },
				{ fieldname: 'comment', fieldtype: 'Small Text', label: __('Your Review') },
			],
			primary_action_label: __('Submit'),
			primary_action: function () {
				var values = d.get_values();
				frappe.call({
					method: 'raftor_webhq.catalog.api.add_template_review',
					args: {
						item_code: itemCode,
						title: values.title,
						rating: values.rating,
						comment: values.comment,
					},
					freeze: true,
					freeze_message: __('Submitting Review ...'),
					callback: function (r) {
						if (!r.exc) {
							frappe.msgprint({
								message: __('Thank you for the review'),
								title: __('Review Submitted'),
								indicator: 'green',
							});
							d.hide();
							location.reload();
						}
					},
				});
			},
		});
		d.show();
	}
});
